/* eslint-disable consistent-return */
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { DatePicker, Button, Row, Col, Form } from "antd";
import Modal from "antd/lib/modal/Modal";
import { jwtDecode } from "jwt-decode";
import moment from "moment";
import { displayFormat, toHttpFormatStartOfDay } from "../../lib/utils/formatDate";
import { postBillPrepayment } from "../../store/slices/bills";
import AuthService from "../../services/AuthService";

const dateFormat = displayFormat;

const BillPrepayments = () => {
  const userName = jwtDecode(AuthService.getCurrentUser());
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [activeModal, setActiveModal] = useState(false);
  const startOfMonth = moment().startOf("month");
  const [date, setDate] = useState(toHttpFormatStartOfDay(startOfMonth));
  const [calendarValue, setCalendarValue] = useState(startOfMonth);

  const layoutCol1 = {
    wrapperCol: { span: 12 },
  };

  const style = {
    modalHeader: {
      fontSize: "14px",
      color: "#5D6C7A",
    },
    modalSubHeader: {
      fontSize: "16px",
      color: "#112244",
    },
    modalInitiator: {
      fontSize: "14px",
      color: "#5D6C7A",
      label: {
        color: "#000000",
        marginLeft: "5px",
      },
    },
    modalFooter: {
      fontSize: "16px",
      color: "#112244",
    },
  };

  const onChangeDate = (value) => {
    setDate(toHttpFormatStartOfDay(value));
    setCalendarValue(value);
  };

  const onFinish = async () => {
    setActiveModal(false);
    dispatch(
      postBillPrepayment({
        date,
      })
    );
  };

  return (
    <>
      <h3 className="invoice-period-header">Параметры запуска</h3>
      <Form name="dynamic_form_nest_item" onFinish={onFinish} form={form} autoComplete="off">
        <Row align="top" style={{ paddingBottom: "10%" }}>
          <Col span={12}>
            <Form.Item
              label="Дата счета"
              labelAlign="left"
              rules={[{ required: true }]}
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...layoutCol1}
            >
              <DatePicker
                allowClear={false}
                onChange={onChangeDate}
                defaultValue={startOfMonth}
                value={calendarValue}
                style={{ minWidth: "140px" }}
                format={dateFormat}
                // disabledDate={(cur) => {
                //   if (cur.date() !== 1) {
                //     return cur;
                //   }
                // }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row align="center" style={{ borderTop: "1px solid #CCDDEE", paddingTop: "15px" }}>
          <Button type="primary" onClick={() => setActiveModal(true)}>
            Создать задание
          </Button>
        </Row>
      </Form>

      <Modal
        visible={activeModal}
        onCancel={() => setActiveModal(false)}
        onOk={onFinish}
        cancelText="Отмена"
        okText="Далее"
        bodyStyle={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "200px",
          fontSize: "16px",
        }}
      >
        <p style={style.modalHeader}>Будет сформировано задание на выполнение операции</p>
        <p style={style.modalSubHeader}>Выставление счетов на предоплату</p>
        <p style={style.modalInitiator}>
          Инициатор:
          <span style={style.modalInitiator.label}>{userName.display_name}</span>
        </p>
        <p style={style.modalFooter}>Для продолжения нажмите «Далее»</p>
      </Modal>
    </>
  );
};

export default BillPrepayments;
